import SourceCard from './SourceCard';
import { useCitationHealth } from '../../hooks/useCitationHealth';

/**
 * CitationList — renders citations with async dead-link detection.
 *
 * Owns the useCitationHealth lifecycle so that SourceCard stays
 * a pure presentational component.
 */
export default function CitationList({ citations, clientId, requestId }) {
  const { deadUrls } = useCitationHealth(citations, clientId, requestId);

  return (
    <div className="space-y-1">
      {citations.map((citation, i) => (
        <SourceCard
          key={i}
          url={citation.url}
          title={citation.title}
          summary={citation.summary}
          tags={citation.tags}
          index={i}
          content_type={citation.content_type}
          content_authority={citation.content_authority}
          doc_date={citation.doc_date}
          isDead={deadUrls.has(citation.url)}
        />
      ))}
    </div>
  );
}
